module.exports = __webpack_public_path__ + "static/ma-5-ae8c43c3c0375c99edbe718609d5932b.png";